import { LI, UL } from "../../../../AbstractElements";
import { LayoutTypeProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";

const RTL = ({ handleLayout, layout_type }: LayoutTypeProp) => {
  return (
    <LI className={`${layout_type === "rtl" ? "active" : ""}`} onClick={() => handleLayout("rtl")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <UL className="simple-list d-flex flex-row">
          <LI className="bg-light body">
            <span className="badge badge-primary">RTL</span>
          </LI>
          <LI className="bg-light sidebar"></LI>
        </UL>
      </div>
    </LI>
  );
};

export default RTL;
